module.exports = __webpack_public_path__ + "img/sparkle-rich.55ce2917.gif";